import { reduxForm } from 'redux-form'

//@ts-ignore
import { destroy } from 'shared/LKGrid'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

import { FORM_NAME, type, LKGRID_NAME } from '../constants'

import { actions } from '../../DetailsContainer'
import { translateLKMessage } from '../translate'
import { addOfficerAssistant } from 'src/store/loan'
import { AddOfficerAssistantParams } from '@lk/api'

export default reduxForm({
  form: FORM_NAME,
  onSubmit: async (
    values: { ManagerId: number; comment: string },
    dispatch: any,
    ownProps: { ID: string; hash: string; name: string },
  ) => {
    const page = ownProps.name
    try {
      // await Loan.addOfficerAssistant({
      //   ...values,
      //   page,
      //   LoanID: ownProps.ID,
      //   HashSum_LoanID_: ownProps.hash,
      // })

      //UPDATED API REQUEST loan_oper_api page: assistantadd, officeradd
      const result = await dispatch(
        addOfficerAssistant({
          ...values,
          page,
          LoanID: ownProps.ID,
          HashSum_LoanID_: ownProps.hash,
        } as unknown as AddOfficerAssistantParams),
      )

      if (!addOfficerAssistant.fulfilled.match(result)) {
        throw { Error: { Message: result.payload } }
      }

      dispatch([
        LKModalActions.close(page),
        destroy(LKGRID_NAME),
        actions.fetchPage({
          type: 'Loan',
          ID: ownProps.ID,
          hash: ownProps.hash,
          page: page === type.officer ? 'officer' : 'officerassistant',
        }),
      ])
    } catch (error) {
      dispatch(LKModalActions.openError(translateLKMessage(error.Error.Message || error.Error.Text)))
    }
  },
})
